import * as actionTypes from "../Actions/ActionTypes";

const initialState = {
  loading: false,
  paymentData: {},
  paymentIntent: {},
  error: null,
  authToken: null,
};

const PaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    // get payment history
    case actionTypes.PAYMENT_HISTORY_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.PAYMENT_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentData: action.payload,
        error: null,
      };
    case actionTypes.PAYMENT_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // delete payment history
    case actionTypes.DELETE_PAYMENT_HISTORY_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DELETE_PAYMENT_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentData: action.payload,
        error: null,
      };
    case actionTypes.DELETE_PAYMENT_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // create payment intent
    case actionTypes.PYMENT_INTENT_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.PYMENT_INTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentIntent: action.payload,
        error: null,
      };
    case actionTypes.PYMENT_INTENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default PaymentReducer;
